import { useOutletContext } from 'react-router-dom';
import ImageHoverPopup from '../../../components/ImageHoverPopup';
import titleCaseString from '../../../utils/titleCaseUtils';
import { Skeleton } from '@mui/material';
import ChangeEmailForm from './pages_security/ChangeEmailForm';
import ChangePasswordForm from './pages_security/ChangePasswordForm';
import Change2FA from './pages_security/Change2FA';

const PageSecurity = ()=> {


    const {details,isLoading} = useOutletContext();
    console.log("detailsx",details);


    return (
        <>
      <ChangeEmailForm/>

      <ChangePasswordForm/>

      <Change2FA/>


         <div className="card card-action mb-4 d-none">
            <div className="card-header">
                <div className="d-flex mb-3 gap-3">
                    <div>
                        <span className="badge bg-label-primary rounded-2">
                            <i className="bx bx-user bx-md" />
                        </span>
                    </div>
                    <div>
                        <h4 className="mb-0">
                            <span className="align-middle">Security</span>
                        </h4>
                        <span>Enable 2FA and change your password regularly.</span>
                    </div>
                </div>
            </div>

 
                <h5 className="card-header">Change Password</h5>
                <div className="card-body">
                    <form id="formChangePassword" method="GET" onsubmit="return false" className="fv-plugins-bootstrap5 fv-plugins-framework" noValidate="novalidate">
                        <div className="alert alert-warning" role="alert">
                            <h6 className="alert-heading mb-1">Ensure that these requirements are met</h6>
                            <span>Minimum 8 characters long, uppercase &amp; symbol</span>
                        </div>
                        <div className="row">
                            <div className="mb-3 col-12 col-sm-6 form-password-toggle fv-plugins-icon-container">
                                <label className="form-label" htmlFor="newPassword">New Password</label>
                                <div className="input-group input-group-merge has-validation">
                                    <input className="form-control" type="password" id="newPassword" name="newPassword" placeholder="············" />
                                    <span className="input-group-text cursor-pointer"><i className="bx bx-hide" /></span>
                                </div><div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
                            </div>
                            <div className="mb-3 col-12 col-sm-6 form-password-toggle fv-plugins-icon-container">
                                <label className="form-label" htmlFor="confirmPassword">Confirm New Password</label>
                                <div className="input-group input-group-merge has-validation">
                                    <input className="form-control" type="password" name="confirmPassword" id="confirmPassword" placeholder="············" />
                                    <span className="input-group-text cursor-pointer"><i className="bx bx-hide" /></span>
                                </div><div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
                            </div>
                            <div>
                                <button type="submit" className="btn btn-primary me-2">Change Password</button>
                            </div>
                        </div>
                        <input type="hidden" /></form>
                </div>
    
        </div>


        <div className="card mb-4 d-none">
  <div className="card-header">
    <h5 className="card-title mb-2">Two-steps verification</h5>
    <span className="card-subtitle">Keep your account secure with authentication step.</span>
  </div>
  <div className="card-body">
    <h6>SMS</h6>
    <div className="d-flex justify-content-between border-bottom mb-4 pb-2">
      <span>+1(968) 945-8832</span>
      <div className="action-icons">
        <a href="javascript:;" className="text-body me-1" data-bs-target="#enableOTP" data-bs-toggle="modal"><i className="bx bx-edit" /></a>
        <a href="javascript:;" className="text-body"><i className="bx bx-trash-alt" /></a>
      </div>
    </div>
    <p className="mb-0">
      Two-factor authentication adds an additional layer of security to your account by requiring more
      than just a password to log in.
      <a href="javascript:void(0);" className="text-body">Learn more.</a>
    </p>
  </div>
</div>


</>

    );
}
 
export default PageSecurity;